import styles from './FilterBar.module.css';

export default function FilterBar({ categories, active, onChange, dark = false }) {
  return (
    <div className={styles.bar}>
      {categories.map(cat => (
        <button
          key={cat}
          className={`${styles.btn} ${dark ? styles.btnDark : ''} ${active === cat ? styles.active : ''}`}
          onClick={() => onChange(cat)}
        >
          {cat}
        </button>
      ))}
    </div>
  );
}
